import React, {Component} from 'react';
import { StyledContent } from '../../styles/mixins'
import {  Tabs } from 'antd';
import { StyledCard } from './style';
import NewPost from './newPost';
import AdminSettings from './adminSettings';
import EmailToMembers from './emailToMembers';
import NewTrade from './newTrade';
const TabPane = Tabs.TabPane;

class AdminView extends Component {
  
  state = {
    activeTab: this.props.match.params.tab || 'new-post'
  }
  
  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.tab !== this.props.match.params.tab) {
      this.setState({ activeTab: nextProps.match.params.tab});
    }
  }
  
  onTabChange = (activeTab) => {
    this.setState({
      activeTab,
    });
    this.props.history.push(`/admin/${activeTab}`)
  }
  
  render() {
    return (
      <StyledContent>
        <StyledCard bordered={false}>
          <Tabs defaultActiveKey="profile" activeKey={this.state.activeTab} onChange={this.onTabChange}>
            <TabPane tab="New Post" key={'new-post'}>
              <NewPost />
            </TabPane>
            <TabPane tab="New Trade" key={'new-trade'}>
              <NewTrade />
            </TabPane>
            <TabPane tab="Email To Members" key={'email'}>
              <EmailToMembers />
            </TabPane>
            <TabPane tab="Settings" key={'settings'}>
              <AdminSettings/>
            </TabPane>
          </Tabs>
        </StyledCard>
      </StyledContent>
    );
  }
}

export default AdminView;





// WEBPACK FOOTER //
// ./src/components/Admin/index.js